import {useQuery} from "@tanstack/react-query";
import client from '../../utils/Client'
import { normalizePaged } from "../../utils/helpers";


// ------- NEW: server-side search -------
const searchFormTypes = (params) =>
  client.get(`forms/types/search`, { params });

export const useSearchFormTypes = (filters) =>
  useQuery(
    ["types-search", filters],
    async () => {
      const { data } = await searchFormTypes(filters);
      return normalizePaged(
        data?.result ?? data,
        { pageNumber: filters?.PageNumber ?? 1, pageSize: filters?.PageSize ?? 20 }
      );
    },
    {
      enabled: !!filters,            // only when we actually search
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: 1,
    }
  );

// ------- existing (kept as-is) -------
const formTypes = (pageNumber = 1, pageSize = 100) =>
  client.get(`forms/types?pageNumber=${pageNumber}&pageSize=${pageSize}`);

export const useGetFormTypes = (pageNumber = 1, pageSize = 100) =>
  useQuery(
    ["types", pageNumber, pageSize],
    () => formTypes(pageNumber, pageSize),
    { select: (res) => res?.data?.result, refetchInterval: 60_000 }
  );

  export const useGetFormTypesPaged = (pageNumber = 1, pageSize = 20) =>
  useQuery(
    ["types-paged", pageNumber, pageSize],
    async () => {
      const { data } = await client.get(
        `forms/types?pageNumber=${pageNumber}&pageSize=${pageSize}`
      );
      return normalizePaged(data?.data ?? data, { pageNumber, pageSize });
    },
    {
      keepPreviousData: true,
      refetchInterval: 60_000,
    }
  );
// GET  FORM TYPE
const formType = (id) => client.get(`forms/type/${id}`);
export const useGetFormType = (id) => useQuery(['type',id], () =>formType(id), {select: data => data?.data?.result,refetchInterval:60_000})


// GET ALL FORM FIELD TYPES
const formFieldTypes = () => client.get('forms/fieldTypes');
export const useGetFormFieldTypes = () => useQuery(['fieldTypes'], () =>formFieldTypes(), {select: data => data?.data?.result,refetchInterval:60_000})


// GET ALL FORM FIELDS

const formsFields = (formId) => client.get(`forms/${formId}/sections`);
export const useFormFields = (formId) => useQuery(['formFields', formId],() => formsFields(formId),{select: data => data?.data?.result})


/* INTERNAL USERS*/


// GET ALL ACTIVE FORM PER USER AND ROLE
const activeFormTypes = (roleId, branchId, from = "", to = "", pageNumber = 1, pageSize = 10) =>
  client.get(
    `forms/active/${branchId}/${roleId}?from=${from}&to=${to}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  );

export const useGetActiveFormTypes = (
  roleId,
  branchId,
  from = "",
  to = "",
  pageNumber = 1,
  pageSize = 10
) =>
  useQuery(
    ["activeForm", roleId, branchId, from, to, pageNumber, pageSize],
    async () => {
      const { data } = await activeFormTypes(roleId, branchId, from, to, pageNumber, pageSize);
      return normalizePaged(data?.data ?? data, { pageNumber, pageSize });
    },
    {
      keepPreviousData: true,
      refetchInterval: 60_000,
      enabled: !!roleId && !!branchId,
    }
  );

/* const activeFormTypes = (roleId,branchId,from='',to='',pageNumber=1,pageSize=10) => client.get(`forms/active/${branchId}/${roleId}?from=${from}&to=${to}&pageNumber=${pageNumber}&pageSize=${pageSize}`);
export const useGetActiveFormTypes = (roleId,branchId,from,to,pageNumber,pageSize) => useQuery(['activeForm', roleId, branchId, from, to], () =>activeFormTypes(roleId,branchId,from,to,pageNumber,pageSize), {select: data => data?.data?.result,refetchInterval:60_000}) */





const pastForms = (
  officerId,
  branchId,
  from = "",
  to = "",
  pageNumber = 1,
  pageSize = 10
) =>
  client.get(
    `forms/past/${officerId}/${branchId}?from=${from}&to=${to}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  );

export const useGetPastForms = (
  officerId,
  branchId,
  from = "",
  to = "",
  pageNumber = 1,
  pageSize = 10
) =>
  useQuery(
    ["pastForms", officerId, branchId, from, to, pageNumber, pageSize],
    async () => {
      const { data } = await pastForms(
        officerId,
        branchId,
        from,
        to,
        pageNumber,
        pageSize
      );
      return normalizePaged(data?.data ?? data, { pageNumber, pageSize });
    },
    {
      enabled: !!officerId && !!branchId,
      keepPreviousData: true,
      refetchInterval: 60_000,
    }
  );


// GET ALL FORMS ACCESSIBLE BY PRIVILEGE
// ---------- PRIVILEGE: base list ----------
const privilegeAccessForms = (officerId, from = "", to = "", pageNumber = 1, pageSize = 10) =>
  client.get(
    `forms/byPrivilege/${officerId}?from=${from}&to=${to}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  );

export const useGetPrivilegeAccessForms = (
  officerId,
  from = "",
  to = "",
  pageNumber = 1,
  pageSize = 10
) =>
  useQuery(
    ["byPrivilege", officerId, from, to, pageNumber, pageSize],
    async () => {
      const { data } = await privilegeAccessForms(officerId, from, to, pageNumber, pageSize);
      return normalizePaged(data?.data ?? data, { pageNumber, pageSize });
    },
    {
      enabled: !!officerId,
      keepPreviousData: true,
      refetchInterval: 60_000,
    }
  );


// GET NON ENGAGED FORM ACCESSIBLE BY PRIVILEGE 
const nonEngagedForm = (formId,officerId) => client.get(`forms/engage/${formId}/${officerId}`);
export const useGetNonEngagedForm = (formId,officerId) => useQuery(['enagaged'], () =>nonEngagedForm(formId,officerId), {select: data => data?.data?.result,refetchInterval:60_000})


// GET SECTION BY FORMTYPE ID PRIVILEGE
const formSection = (formId) => client.get(`forms/${formId}/officialSections`);
export const useGetFormSection = (formId) => useQuery(['officialSection',formId ], () =>formSection(formId), {select: data => data?.data?.result,refetchInterval:60_000})

// ---- SEARCH ----------------------------------------------------------------
const searchForms = (params) => client.get("forms/search", { params });

export const useSearch = (filters) =>
  useQuery(
    ["forms-search", filters],
    async () => {
      const { data } = await searchForms(filters);
      return normalizePaged(
        data?.result ?? data,
        { pageNumber: filters?.PageNumber ?? 1, pageSize: filters?.PageSize ?? 20 }
      );
    },
    {
      enabled: !!filters,              // only runs when filters are set
      refetchOnWindowFocus: false,
      keepPreviousData: true,          // keep old page while the next loads
      retry: 1,
      staleTime: 30_000,
    }
  );



  // Backend expects OfficerId + optional filters (TicketNo, RequestValue, FormTypeId, BranchId, StartDate, EndDate, PageNumber, PageSize)
// ---------- PRIVILEGE: search ----------
const searchPrivilege = (officerId, params) =>
  client.get(`forms/searchByPrivilege/${officerId}`, { params });

export const useGetSearchedPrivilege = (officerId, filters) =>
  useQuery(
    ["forms-privilege-search", officerId, filters],
    async () => {
      const { data } = await searchPrivilege(officerId, filters);
      return normalizePaged(
        data?.result ?? data,
        { pageNumber: filters?.PageNumber ?? 1, pageSize: filters?.PageSize ?? 20 }
      );
    },
    {
      enabled: !!officerId && !!filters,
      keepPreviousData: true,     // keep old page while fetching the next
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    }
  );

  // strip empty params so we only send meaningful filters
const compactParams = (obj) =>
  Object.fromEntries(
    Object.entries(obj || {}).filter(
      ([, v]) => !(v === null || v === undefined || v === "" || (typeof v === "number" && Number.isNaN(v)))
    )
  );

// ---------- HISTORY: searched past forms ----------
const getSearchedPastForms = (officerId, branchId, filters) =>
  client.get(`forms/history/searchByPast/${officerId}`, {
    params: compactParams({ BranchId: branchId, ...filters }),
  });

export const useGetSearchedPastForms = (officerId, branchId, filters) =>
  useQuery(
    ["forms-history-search", officerId, branchId, filters],
    async () => {
      const { data } = await getSearchedPastForms(officerId, branchId, filters);
      return normalizePaged(
        data?.result ?? data,
        {
          pageNumber: filters?.PageNumber ?? 1,
          pageSize: filters?.PageSize ?? 20,
        }
      );
    },
    {
      enabled: !!officerId && !!branchId && !!filters,
      keepPreviousData: true,     // smooth page changes
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    }
  );


  export const useGetAttachments = (formId) =>
  useQuery({
    queryKey: ["attachments", formId],
    queryFn: async () => {
      const { data } = await client.get(`forms/${formId}/attachments`);
      // backend shape: { result: AttachmentDto[] }
      return data?.result ?? [];
    },
    enabled: !!formId,
  });